<template>
  <div class="mt-5 flex">

    <div class="m-auto space-y-16">
      <div class="block text-center relative w-[90%] m-auto">
        <img 
          v-if="mapImage" 
          alt="map" 
          class="w-full" 
          :src="mapImage"
        />
        <div 
          v-for="[pointId, point] in validPoints" 
          :key="pointId"
        >
          <MapMarker 
            v-if="point && point.data" 
            :pointId="pointId" 
            :point="point" 
            :onClick="onItemClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import MapMarker from './MapMarker.vue'

export default {
  name: 'VueMap',
  components: {
    MapMarker
  },
  props: {
    currentLocation: {
      type: Object,
      default: null
    },
    points: {
      type: Object,
      required: true
    },
    onItemClick: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      mapImage: null
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    
    // Filter out invalid points
    validPoints() {
      if (!this.points || typeof this.points !== 'object') {
        return []
      }
      return Object.entries(this.points).filter(([pointId, point]) => 
        point && point.data && point.data.map_location
      )
    }
  },
  watch: {
    tourSettings: {
      handler(newSettings) {
        if (newSettings?.navigation?.map?.map_image) {
          this.mapImage = newSettings.navigation.map.map_image.preview_url
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Track page view (mirrors React implementation)
    if (window._paq) {
      window._paq.push(['setCustomUrl', window.location.pathname])
      window._paq.push(['setDocumentTitle', 'Points - Map'])
      window._paq.push(['trackPageView'])
    }
  }
}
</script>

<style scoped>
/* Add any additional styles if needed */
</style> 